export class InsertAddress {
  addressKeys: string[];
  blockId: string;

  constructor(keys: string[], areaId: string) {
    this.addressKeys = keys;
    this.blockId = areaId;
  }
}
